import PropTypes from 'prop-types';
import { useState } from 'react';
import './BlocoEItensFormularioAcompanhamento.css';

const BlocoEItensFormularioAcompanhamento = ({ blocoItem, respostas, adicionaItemFormulario }) => {

    console.log('### Iniciando BlocoEItensFormularioAcompanhamento ###');

    const limiteCaracteresObs = 250;

    const [itensDoBloco, setItensDoBloco] = useState(() =>
        blocoItem.itens.map(item => ({
            ...item,
            respostaId: null,
            observacao: null,
        }))
    );

    const atualizarResposta = (id, atributo, valor) => {
        setItensDoBloco(prev =>
            prev.map(item =>
                item.id === id ? { ...item, [atributo]: valor } : item
            )
        );
    };

    // Se tudo estiver preenchido, mando pro componente pai
    const tudoPreenchido = itensDoBloco.every(item => item.respostaId !== null);

    if (tudoPreenchido) {
        const listaTratada = itensDoBloco.map(itemRespondido => ({
            respostaId: itemRespondido.respostaId,
            observacao: itemRespondido.observacao,
            modeloItemFormularioAcompanhamentoId: itemRespondido.id
        }))

        adicionaItemFormulario(listaTratada)
    }

    return (
        <div className='formularioContainer'>
            <p className='blocoTitulo'><strong>{blocoItem.blocoItem}</strong></p>
            <table className='tabelaPerguntas'>
                <thead>
                    <tr>
                        <th className='headTabela headTabelaCodigo'>Código</th>
                        <th className='headTabela headTabelaPergunta'>Pergunta</th>
                        <th className='headTabela'>Sim</th>
                        <th className='headTabela'>Não</th>
                        <th className='headTabela'>Parcial</th>
                        <th className='headTabela'>N/A</th>
                        <th className='headTabela'>Observação</th>
                    </tr>
                </thead>
                <tbody>
                    {itensDoBloco && itensDoBloco.map((item) => (
                        <tr key={item.id}>
                            <td className='tableRow'>
                                {blocoItem.id + '.' + item.codigo}
                            </td>
                            <td className='tableRow perguntaContainer'>
                                <p className='pergunta'>{item.descricao} {item.nota && <i><small>{item.nota}</small></i>}</p>
                            </td>
                            {respostas.map((resposta) => (
                                <td key={resposta.id} className='tableRow'>
                                    <input
                                        className='respFormItem'
                                        id={item.id}
                                        type="radio"
                                        name={`respItemId_${item.id}`}
                                        value={resposta.id}
                                        onChange={(e) => atualizarResposta(item.id, 'respostaId', Number(e.target.value))}
                                        required />
                                </td>
                            ))}
                            <td className='tableRow'>
                                <input
                                    className='obsFormItem'
                                    id={item.id}
                                    type="text"
                                    name='observacao'
                                    onBlur={(e) => atualizarResposta(item.id, 'observacao', e.target.value)}
                                    maxLength={limiteCaracteresObs}
                                    required={ item.respostaId !== item.respostaPositiva }
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default BlocoEItensFormularioAcompanhamento;

BlocoEItensFormularioAcompanhamento.propTypes = {
    blocoItem: PropTypes.object.isRequired,
    respostas: PropTypes.arrayOf(PropTypes.object).isRequired,
    adicionaItemFormulario: PropTypes.func.isRequired
};